export class DataForAlertMessage{
    url : string;
    message : string;
    urlType : number;
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/alertScreen.ts